import { render, staticRenderFns } from "./CgvSection.vue?vue&type=template&id=3907a21c&scoped=true&"
import script from "./CgvSection.vue?vue&type=script&lang=js&"
export * from "./CgvSection.vue?vue&type=script&lang=js&"
import style0 from "./CgvSection.vue?vue&type=style&index=0&id=3907a21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3907a21c",
  null
  
)

export default component.exports